import { render } from "./MyTargets.vue?vue&type=template&id=093fbf1d"
import script from "./MyTargets.vue?vue&type=script&lang=js"
export * from "./MyTargets.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__